import {
  Grid,
  Typography,
  Box,
} from "@mui/material";
import { grey } from '@mui/material/colors';
//
// ################################################################################
//
const Item = ({
  label = "-",
  value = "-",
  valueColor = "text.primary",
  valueFontWeight = 500,
  valueAlign = "left",
  xs = 12,
  sm = 6,
  md = 4,
  lg = 4,
  xl = 4 }) => (

  // colores del theme disponibles
  // primary.main
  // secondary.main
  // error.main
  // warning.main
  // info.main
  // success.main
  // text.primary
  // text.secondary

  <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
    <Typography
      variant="body1"
      color="text.primary"
      sx={{ display: "block", mb: 0.5 }}
    >
      {label}
    </Typography>

    <Box
      sx={{
        bgcolor: grey[300],
        px: 1.5,
        py: 0.7,
        borderRadius: 1,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: grey[500],
      }}
    >
      <Typography variant="body1"
        sx={{
          width: "100%",
          color: valueColor,
          fontWeight: valueFontWeight,
          textAlign: valueAlign,
        }}
      >
        {value === undefined || value === null || value === ""
          ? "\u00A0"
          : value}
      </Typography>
    </Box>
  </Grid>
);
export default Item;
